import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const COMBOS = ['Combo 2 — El Más Elegido', 'Combo 3 — Nivel Avanzado'];
const FAKE_BUYERS = [{
  name: 'Martín G.',
  city: 'Buenos Aires',
  avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
}, {
  name: 'Lucía R.',
  city: 'Córdoba',
  avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
}, {
  name: 'Diego F.',
  city: 'Rosario',
  avatar: 'https://randomuser.me/api/portraits/men/45.jpg'
}, {
  name: 'Valentina M.',
  city: 'Mendoza',
  avatar: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  name: 'Sebastián T.',
  city: 'Mar del Plata',
  avatar: 'https://randomuser.me/api/portraits/men/22.jpg'
}, {
  name: 'Carolina P.',
  city: 'La Plata',
  avatar: 'https://randomuser.me/api/portraits/women/25.jpg'
}, {
  name: 'Andrés L.',
  city: 'Tucumán',
  avatar: 'https://randomuser.me/api/portraits/men/67.jpg'
}, {
  name: 'Camila S.',
  city: 'Salta',
  avatar: 'https://randomuser.me/api/portraits/women/33.jpg'
}, {
  name: 'Federico R.',
  city: 'Santa Fe',
  avatar: 'https://randomuser.me/api/portraits/men/51.jpg'
}, {
  name: 'María José D.',
  city: 'Neuquén',
  avatar: 'https://randomuser.me/api/portraits/women/57.jpg'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(FAKE_BUYERS[0]);
  const [currentCombo, setCurrentCombo] = useState(COMBOS[0]);
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    const showPopup = () => {
      const randomBuyer = FAKE_BUYERS[Math.floor(Math.random() * FAKE_BUYERS.length)];
      const randomCombo = COMBOS[Math.floor(Math.random() * COMBOS.length)];
      setCurrentBuyer(randomBuyer);
      setCurrentCombo(randomCombo);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
        const nextInterval = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
        setTimeout(showPopup, nextInterval);
      }, 4000);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-29">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-4 left-4 z-50 max-w-xs w-full bg-zinc-900 border-l-4 border-yellow-500 rounded-lg shadow-2xl p-3 flex items-center gap-3" data-id="element-30">
          <img src={currentBuyer.avatar} alt={currentBuyer.name} className="h-10 w-10 rounded-full object-cover flex-shrink-0 border-2 border-yellow-500/30" data-id="element-31" />
          <div className="flex-1 min-w-0" data-id="element-32">
            <div className="flex items-center gap-1 mb-0.5" data-id="element-33">
              <CheckCircle2 className="w-3 h-3 text-green-500" data-id="element-34" />
              <span className="text-[10px] font-bold text-green-500 uppercase tracking-wider" data-id="element-35">
                Compra verificada
              </span>
            </div>
            <p className="text-xs text-white font-medium truncate" data-id="element-36">
              <span className="font-bold text-yellow-500" data-id="element-37">
                {currentBuyer.name}
              </span>{' '}
              de {currentBuyer.city}
            </p>
            <p className="text-xs text-gray-400 truncate" data-id="element-38">
              adquirió el{' '}
              <span className="text-white font-semibold" data-id="element-39">{currentCombo}</span>
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}